module.exports = __webpack_public_path__ + "static/about-photo-35e30135eb3d8ddecc956fec162467e0.jpg";